(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('topLeftSchema',  topLeftSchemaInject);

  /** @ngInject */
  function topLeftSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/tapWaterSubSystem-resized.svg',
      controller: TopLeftSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function TopLeftSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'value.highFloat', 'value.lowFloat', 'value.pressure', 'value.motorError', 'value.motor'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ?  schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2]  ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[4]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[5] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();
